import { useAppSelector } from 'redux-store';

const useIsAnonymousUser = (): boolean =>
  useAppSelector(state =>
    state.profile.profile?.id ? state.profile.profile.id === 'anonymous' : true,
  );

export default useIsAnonymousUser;
